
export const ROUTE_PATHS = {
    HOME: '/',
    EMPLOYEES: '/employees',
    PRODUCTS: '/products',
    SERVICES: '/services',
    CLIENTS: '/clients',
    FLEETS: '/fleets',
    VEHICLES: '/vehicles',
    ORDERS: '/orders',
    CALENDAR: '/calendar',
    SETTINGS: '/settings',
    EMPLOYEE_DETAILS: '/employees/:id',
    LOGOUT: '/logout',
} as const;

export type RoutePath = (typeof ROUTE_PATHS)[keyof typeof ROUTE_PATHS];
